import React, {FunctionComponent, useEffect, useRef, useState} from "react"
import {IconContext} from "react-icons/lib"
import {TbAsteriskSimple, TbCircleCheck, TbShieldLock, TbUser} from "react-icons/tb"
import {IoMdMore} from "react-icons/io"
import {updateCustomerTrainingSettings} from "../../../common/api/Training/mutations"

interface EducationByCourseActions {
	trainingId: number
	customerId: string
	translations: Record<string, string>
}

const EducationByCourseActions: FunctionComponent<EducationByCourseActions> = ({
	trainingId,
	customerId,
	translations
}) => {
	const dropDownRef = useRef(null)
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const handleClickInside = () => {
		setIsOpen(true)
	}

	function handleClickOutside(e: MouseEvent) {
		// e.preventDefault()
		if ((e.target as HTMLElement).classList.contains("useradmin-dropdown-content")) {
			return
		} else if (
			(e.target as HTMLElement).classList.contains("useradmin-select") ||
			!dropDownRef?.current.contains(e.target as HTMLElement)
		) {
			setIsOpen(false)
		}
	}

	const {mutate: updateSettings, isPending: isUpdating} = updateCustomerTrainingSettings(translations)

	const handleSuccess = () => {
		setIsOpen(false)
	}

	const handleError = () => {}

	const mandatoryForAll = () => {
		updateSettings(
			{
				customerId,
				trainingId,
				mandatoryForUsers: true,
				mandatoryForAdmins: true
			},
			{
				onSuccess: handleSuccess,
				onError: handleError
			}
		)
	}

	const mandatoryForUsers = () => {
		updateSettings(
			{
				customerId,
				trainingId,
				mandatoryForUsers: true,
				mandatoryForAdmins: false
			},
			{
				onSuccess: handleSuccess,
				onError: handleError
			}
		)
	}

	const mandatoryForAdmins = () => {
		updateSettings(
			{
				customerId,
				trainingId,
				mandatoryForUsers: false,
				mandatoryForAdmins: true
			},
			{
				onSuccess: handleSuccess,
				onError: handleError
			}
		)
	}

	const mandatoryForNone = () => {
		updateSettings(
			{
				customerId,
				trainingId,
				mandatoryForUsers: false,
				mandatoryForAdmins: false
			},
			{
				onSuccess: handleSuccess,
				onError: handleError
			}
		)
	}

	const dropDownClasses = isOpen
		? "useradmin-dropdown-content icon-hover-child useradmin-dropdown-content--active"
		: "useradmin-icon-hover useradmin-dropdown-content"

	const isDisabled = isUpdating ? " disabled" : ""

	return (
		<div className='useradmin-more-wrapper' onClick={handleClickInside} ref={dropDownRef}>
			<IconContext.Provider value={{className: "btn-icon actions-more"}}>
				<IoMdMore />
			</IconContext.Provider>
			<div className={dropDownClasses}>
				<div className={`useradmin-select${isDisabled}`} onClick={() => mandatoryForAll()}>
					<IconContext.Provider value={{className: "btn-icon useradmin-more"}}>
						<TbAsteriskSimple />
					</IconContext.Provider>
					<span>{translations.makeMandatoryForAll || "Make mandatory for all"}</span>
				</div>
				<div className={`useradmin-select${isDisabled}`} onClick={() => mandatoryForUsers()}>
					<IconContext.Provider value={{className: "btn-icon useradmin-more"}}>
						<TbUser />
					</IconContext.Provider>
					<span>{translations.makeMandatoryForUsers || "Make mandatory for users"}</span>
				</div>
				<div className={`useradmin-select${isDisabled}`} onClick={() => mandatoryForAdmins()}>
					<IconContext.Provider value={{className: "btn-icon useradmin-more"}}>
						<TbShieldLock />
					</IconContext.Provider>
					<span>{translations.makeMandatoryForAdmins || "Make mandatory for admins"}</span>
				</div>
				<div className={`useradmin-select${isDisabled}`} onClick={() => mandatoryForNone()}>
					<IconContext.Provider value={{className: "btn-icon useradmin-more"}}>
						<TbCircleCheck />
					</IconContext.Provider>
					<span>{translations.makeMandatoryForNone || "Make mandatory for none"}</span>
				</div>
			</div>
		</div>
	)
}

export default EducationByCourseActions
